import { Dispatch, SetStateAction } from 'react'
import { Link, Typography } from '@mui/material'

import FullScreenModal from '../../../components/full-screen-modal'
import useStyles from '../index.styles'

interface IProps {
  audibleOnlyModalVisible: boolean
  setAudibleOnlyModalVisible: Dispatch<SetStateAction<boolean>>
}

const ModalContent = () => {
  const classes = useStyles

  return (
    <Typography variant="body1">
      Your sensor is trying to connect, but you are still protected. If water is detected, your sensor will beep.
      <br />
      <br />
      Remote alerts (SMS, push, email, phone) will be enabled once the device connects.
      <br />
      <br />
      Want to maximize your connectivity?&nbsp;
      <Link
        href="https://resources.meshify.com/defender-slim/#improve-connectivity"
        rel="noopener noreferrer"
        target="_blank"
        underline="hover"
        sx={classes.drawerLink}
      >
        Check out our FAQ tips.
      </Link>
    </Typography>
  )
}

const AudibleAlarmOnlyModal = (props: IProps) => {
  const { audibleOnlyModalVisible, setAudibleOnlyModalVisible } = props

  return (
    <FullScreenModal
      open={audibleOnlyModalVisible}
      onClose={() => setAudibleOnlyModalVisible(false)}
      title="Audible Alarm Only"
      showCloseIcon={true}
      confirmLabel="Okay, got it"
      onConfirm={() => setAudibleOnlyModalVisible(false)}
      isFullScreen={false}
    >
      <ModalContent />
    </FullScreenModal>
  )
}

export default AudibleAlarmOnlyModal
